export interface SuggestionResult {
    name: string;
    suggestions: string[];
}
